import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA__9lzNYabt4-KXXz-28etDWI5vAYzaL0",
  authDomain: "centralgroup-ecde5.firebaseapp.com",
  projectId: "centralgroup-ecde5",
  storageBucket: "centralgroup-ecde5.firebasestorage.app",
  messagingSenderId: "920957317043",
  appId: "1:920957317043:web:6b5b1ad40bf36e3ed7e5c6",
  measurementId: "G-F9KXN87M9N",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Analytics and Storage
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
